// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewFieldValueResponse } from './rapid-review-field-value-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewOdOsResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewOdOsResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	name!: string;

	@GandalfProperty({ designType: RapidReviewFieldValueResponse })
	odField!: RapidReviewFieldValueResponse | null;

	@GandalfProperty({ designType: RapidReviewFieldValueResponse })
	osField!: RapidReviewFieldValueResponse | null;

}
